import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import {
  getTodayDate,
  validateRegistration,
} from "../../../../common/Validations";
import TableDropdownMenu from "../../../../Components/TableDropdownMenu/TableDropdownMenu";

//API
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";

const LoadingAdviceModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const [isCardVisible1, setCardVisible1] = useState(true);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [lineItmes, setLineItems] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [viewStatus, setViewStatus] = useState(false);
  const [propsData, setPropsData] = useState();
  const [formInputs, setFormInputs] = useState();
  const [godownData, setGodownData] = useState([]);
  const [truckData, setTruckData] = useState([]);

  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    setPropsData(props.loadingadvicedata);
  }, [props?.loadingadvicedata]);

  const lineItemCol = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
          <p className="m-0 p-0 ">{row?.materialCode} </p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.orderQuantityLoad} </p>
          <p className="m-0 p-0 ">{row?.uOM} </p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Load Qty",
      cell: (row) => (
        <>
          <InputField
            // type="number"
            className="inputBox mt-1"
            // label="Date"
            name="orderQtyLoadConfirm"
            id="orderQtyLoadConfirm"
            value={
              row?.orderQtyLoadConfirm !== undefined &&
              row?.orderQtyLoadConfirm !== null
                ? row.orderQtyLoadConfirm
                : ""
            }
            onChange={(event) => handleInputChange(row?.local_id, event)}
            disabled={row?.balanceQty === 0 ? true : false}
          />
        </>
      ),
      width: "130px",
    },
    {
      name: "Balance Load Qty",
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            // label="Date"
            name="balanceQty"
            id="balanceQty"
            value={row?.balanceQty}
            // value={
            //   row?.balanceQty ??
            //   row?.orderQuantityLoad - (row?.orderQtyLoadConfirm || 0)
            // }
            // onChange={(event) => handleInputChange(row?.local_id, event)}
            disabled={true}
          />
        </>
      ),
      width: "140px",
    },
    {
      name: "Date",
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            // label="Date"
            name="loadingDate"
            id="loadingDate"
            type="date"
            value={row?.loadingDate}
            onChange={(event) => handleInputChange(row.local_id, event)}
            disabled={viewStatus}
          />
        </>
      ),
      width: "160px",
    },
    {
      name: "Time",
      cell: (row) => (
        <>
          <InputField
            className="inputBox"
            label=""
            name="loadingTime"
            id="loadingTime"
            type="time"
            value={row?.loadingTime}
            onChange={(event) => handleInputChange(row.local_id, event)}
            disabled={viewStatus}
          />
        </>
      ),
      width: "160px",
    },
    {
      name: "Ex-work",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.exWork || "--"} </p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Godown",
      cell: (row) => (
        <>
          {viewStatus ? (
            <InputField
              className="inputBox"
              // label="Godown"
              name="godownAddress"
              id="godownAddress"
              value={row.godownAddress}
              // onChange={(event) => handleInputChange(row?.local_id, event)}
              disabled={viewStatus}
            />
          ) : (
            <TableDropdownMenu
              index={row?.local_id}
              label={"Godown"}
              data={godownData}
              id={"godownAddress"}
              name={"godownAddress"}
              code={"godownAddressCode"}
              description={"godownAddressDescription"}
              onChange={handleDropdownChange}
              // required={true}
            />
          )}
        </>
      ),
      sortable: true,
      width: "280px",
    },
    {
      name: "Truck No",
      cell: (row) => {
        if (row?.exWork && row?.exWork === "Ex-Work") {
          return null; // 👈 completely hide column cell
        }

        return (
          <>
            {viewStatus ? (
              <InputField
                className="inputBox"
                name="loadingTruckNo"
                id="loadingTruckNo"
                value={row.loadingTruckNo}
                disabled={viewStatus}
              />
            ) : (
              <TableDropdownMenu
                index={row?.local_id}
                label={"Truck No"}
                data={truckData}
                id={"loadingTruckNo"}
                name={"loadingTruckNo"}
                code={"loadingTruckNoCode"}
                description={"loadingTruckNoDescription"}
                onChange={handleDropdownChange}
              />
            )}
          </>
        );
      },
      sortable: true,
      width: "200px",
    },

    // {
    //   name: "Truck No",
    //   cell: (row) => (
    //     <>
    //       { (viewStatus) ? (
    //         <InputField
    //           className="inputBox"
    //           // label="Truck No"
    //           name="loadingTruckNo"
    //           id="loadingTruckNo"
    //           value={row.loadingTruckNo}
    //           // onChange={(event) => handleInputChange(row?.local_id, event)}
    //           disabled={viewStatus}
    //         />
    //       ) : (
    //         <>
    //           <TableDropdownMenu
    //             index={row?.local_id}
    //             label={"Truck No"}
    //             data={truckData}
    //             id={"loadingTruckNo"}
    //             name={"loadingTruckNo"}
    //             code={"loadingTruckNoCode"}
    //             description={"loadingTruckNoDescription"}
    //             onChange={handleDropdownChange}
    //             // required={true}
    //           />
    //         </>
    //       )}
    //     </>
    //   ),
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Other TruckNo",
      cell: (row) => (
        <>
          {row?.loadingTruckNoCode === "000" && (
            <InputField
              className="inputBox"
              name="loadingOtherTruckNo"
              id="loadingOtherTruckNo"
              value={row?.loadingOtherTruckNo}
              onChange={(event) => handleInputChange(row.local_id, event)}
              disabled={false}
            />
          )}
        </>
      ),
      width: "160px",
    },
    {
      name: "Driver Name",
      cell: (row) => (
        <>
          <InputField
            className="inputBox"
            // label="Driver Name"
            name="transporterDriverName"
            id="transporterDriverName"
            value={row?.transporterDriverName}
            onChange={(event) => handleInputChange(row.local_id, event)}
            disabled={viewStatus}
          />
        </>
      ),
      width: "160px",
    },
    {
      name: "Driver Contact",
      cell: (row) => (
        <>
          <InputField
            className="inputBox"
            // label="Driver Contact"
            name="transporterDriverContact"
            id="transporterDriverContact"
            onChange={(event) => handleInputChange(row.local_id, event)}
            value={row?.transporterDriverContact}
            disabled={viewStatus}
          />
        </>
      ),
      width: "160px",
    },
    {
      name: "Shipped Party",
      cell: (row) => (
        <>
          <TextAreaField
            className="inputBox"
            // label="Driver Contact"
            name="shippedParty"
            id="shippedParty"
            onChange={(event) => handleInputChange(row.local_id, event)}
            value={row?.shippedParty}
            disabled={viewStatus}
          />
        </>
      ),
      width: "160px",
    },

    // {
    //   name: "Unit Price",
    //   cell: (row) => <span>{row.unitPrice} </span>,
    //   width: "130px",
    // },
    // {
    //   name: "Rate",
    //   cell: (row) => <span>{row.rate} </span>,
    //   width: "130px",
    // },
    // {
    //   name: "Customer Name",
    //   cell: (row) => (
    //     <>
    //       <p>{row?.customerName}</p>
    //     </>
    //   ),
    //   width: "130px",
    // },
    {
      name: "Shipping Addr",
      cell: (row) => (
        <>
          <p>{row?.shippingAddress}</p>
        </>
      ),
      width: "180px",
    },
    {
      name: "Shipping Postal Code",
      cell: (row) => (
        <>
          <p>{row?.shippingPostalCode}</p>
        </>
      ),
      width: "160px",
    },
  ];

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  //handle cancel modal
  const handleCancel = () => {
    props.onHide();
  };

  //handle save
  const handleSave = async () => {
    // Filter out records where orderQtyLoadConfirm <= 0
    const validItems = lineItmes.filter(
      (updatedItem) => parseFloat(updatedItem.orderQtyLoadConfirm) > 0
    );

    // Ensure at least one valid record exists
    if (validItems.length === 0) {
      toast.error("At least one valid record is required!", {
        duration: 4000,
        position: "top-right",
      });
      return; // Stop execution if no valid records
    }

    // Check if any remaining item has orderQtyLoadConfirm > balanceQty
    const isInvalid = validItems.some((updatedItem) => {
      const orderQtyLoadConfirm = parseFloat(updatedItem.orderQtyLoadConfirm);
      const balanceQty =
        parseFloat(updatedItem.balanceQty) ||
        parseFloat(updatedItem.orderQuantityLoad);

      if (orderQtyLoadConfirm > balanceQty) {
        toast.error("Load Qty should not be greater than Balance Qty!", {
          duration: 4000,
          position: "top-right",
        });
        return true; // Stop checking further
      }
      return false;
    });

    if (isInvalid) return; // Stop execution if validation fails

    const isMissingGodownAddress = validItems.some(
      (item) => !item.godownAddress || item.godownAddress.trim() === ""
    );
    if (isMissingGodownAddress) {
      toast.error("Please fill the Godown Address", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    // ✅ Validate loadingTruckNo is selected
    const isMissingTruckNo = validItems.some(
      (item) => !item.loadingTruckNo || item.loadingTruckNo.trim() === ""
    );
    if (isMissingTruckNo) {
      toast.error("Please fill the Loading Truck No!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    // // ✅ If "OTHERS", validate loadingOtherTruckNo
    // const isMissingOtherTruckNo = validItems.some(
    //   (item) =>
    //     item.loadingTruckNo === "000 - OTHERS" &&
    //     (!item.loadingOtherTruckNo || item.loadingOtherTruckNo.trim() === "")
    // );
    // if (isMissingOtherTruckNo) {
    //   toast.error(
    //     "Please fill 'Other Truck No'",
    //     {
    //       duration: 4000,
    //       position: "top-right",
    //     }
    //   );
    //   return;
    // }
    // Check for missing or invalid "Other Truck No"
    const isMissingOrInvalidOtherTruckNo = validItems.some((item) => {
      const isOthers = item.loadingTruckNo === "000 - OTHERS";
      const otherTruckNo = item.loadingOtherTruckNo?.trim() || "";

      // Show error if empty
      if (isOthers && !otherTruckNo) {
        toast.error("Please fill 'Other Truck No'", {
          duration: 4000,
          position: "top-right",
        });
        return true;
      }

      // Show error if invalid format
      if (isOthers && !validateRegistration(otherTruckNo)) {
        toast.error("Invalid vehicle number format in 'Other Truck No'", {
          duration: 4000,
          position: "top-right",
        });
        return true;
      }

      return false;
    });
    if (isMissingOrInvalidOtherTruckNo) return;

    // ✅ Validate loadingTruckNo is selected
    const shippedPartyEmpyt = validItems.some(
      (item) => !item.shippedParty || item.shippedParty.trim() === ""
    );
    if (shippedPartyEmpyt) {
      toast.error("Please fill the Shipped Party", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    const updatedData = {
      ...formInputs, // Include existing form inputs
      items: validItems, // Merge latest line items
      updateLoadingStatus: true, // Update status
    };

    // console.log(">>obj", updatedData);
    setDisabled(true);
    await ItemServiceV2.updateLoading(updatedData).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        handleSearchFuncApi();
        toast.success(item?.message || "Updated Successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
      } else {
        // setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
      setDisabled(false);
    });
  };

  const handleInputChange = (localId, event) => {
    const { name, value } = event.target;
    setLineItems((prevData) =>
      prevData.map((item) => {
        if (item.local_id === localId) {
          const newValue =
            name === "loadingOtherTruckNo" ? value.toUpperCase() : value;
          let updatedItem = { ...item, [name]: newValue };
          // let updatedItem = { ...item, [name]: value };

          // Only update balanceQty if orderQtyLoadConfirm is changed
          // if (name === "orderQtyLoadConfirm") {
          //   if (
          //     parseFloat(updatedItem.orderQtyLoadConfirm) >
          //     (parseFloat(updatedItem.balanceQty) ||
          //       parseFloat(updatedItem.orderQuantityLoad))
          //   ) {
          //     toast.error("Load Qty Should not greater than Balance Qty!!", {
          //       duration: 4000,
          //       position: "top-right",
          //     });
          //   }
          // }
          if (name === "orderQtyLoadConfirm") {
            const value = updatedItem.orderQtyLoadConfirm;

            // Check if it's not a valid number
            if (isNaN(value) || value.trim() === "") {
              toast.error("Please enter a valid number for Load Qty", {
                duration: 4000,
                position: "top-right",
              });
            } else if (
              parseFloat(value) >
              (parseFloat(updatedItem.balanceQty) ||
                parseFloat(updatedItem.orderQuantityLoad))
            ) {
              toast.error("Load Qty should not be greater than Balance Qty!!", {
                duration: 4000,
                position: "top-right",
              });
            }
          }
          return updatedItem;
        }
        return item;
      })
    );
  };

  // Capture the data from dropdown
  const handleDropdownChange = (data) => {
    setLineItems((prevRows) =>
      prevRows.map((row) =>
        row.local_id === data.index
          ? {
              ...row,
              [data.name]: data.value,
              [data.code]: data.codeValue,
              [data.desc]: data.descValue,
            }
          : row
      )
    );
  };
  useEffect(() => {
    let needsUpdate = false;

    const updated = lineItmes?.map((row) => {
      if (row.exWork === "Ex-Work" && row.loadingTruckNo !== "000 - OTHERS") {
        needsUpdate = true;
        return {
          ...row,
          loadingTruckNo: "000 - OTHERS",
          loadingTruckNoCode: "000",
          loadingTruckNoDescription: "OTHERS",
        };
      }
      return row;
    });

    if (needsUpdate) {
      setLineItems(updated); // ✅ only updates when necessary
    }
  }, [lineItmes]);

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getOrderScheduleBookingListV1",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getOrderSchedulingList(obj));
  };

  //call api for paritcular order
  const getMasterData = async () => {
    if (!propsData?.orderSchedulingNr) return;
    let obj = { documentNumber: propsData?.orderSchedulingNr };
    setLineItems([]);
    await ItemServiceV2.getOrderBoogkingDetail(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        let itemData = item?.data[0]?.items;
        // Update existing records
        let updateItemData = itemData.map((item, index) => ({
          ...item,
          orderQtyLoadConfirm: 0,
          loadingDate: getTodayDate(""),
          loadingTime: getCurrentTime(),
          shippedParty: item?.customerName || propsData?.customerName,
        }));

        setLineItems(updateItemData || []);
        setFormInputs(item?.data[0]);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    // Get warehouse data
    let obj1 = {
      codeType: "warehouse",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setGodownData(item.data || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    // Get warehouse data
    // let obj2 = {
    //   codeType: "truckCode",
    // };
    // await ItemService.getMasterData(obj2).then((item) => {
    //   // console.log(">> item! title", item);
    //   if (item?.status === 200) {
    //     setTruckData(item.data || []);
    //   } else {
    //     console.log(">> Error: Loading getMasterDataSelf");
    //   }
    // });

    let obj3 = {
      queryName: "get_vehicleRegistrationNr",
    };

    await ItemService.generateCustomerQuery(obj3).then((item) => {
      console.log(">> item! title", item?.data);
      if (item?.status === 200 && Array.isArray(item?.data)) {
        const updatedData = [
          ...item.data,
          {
            codeType: "truckCode",
            code: "000",
            description: "OTHERS",
            name: "000 - OTHERS",
            id: "000",
          },
        ];
        setTruckData(updatedData);
      } else {
        setTruckData([]);
        console.log(">> Error: Loading Company Code");
      }
    });

    // let obj3= {
    //  queryName: "get_vehicleRegistrationNr",
    // }
    // await ItemService.generateCustomerQuery(obj3).then((item) => {
    //   console.log(">> item! title", item?.data);
    //   if (item?.status === 200) {
    //     // setTruckData(item?.data);
    //   } else {
    //     // setTruckData([]);
    //     console.log(">> Error: Loading Company Code");
    //   }
    // });
  };

  useEffect(() => {
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsData]);

  //get current time
  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5); // Format HH:mm (24-hour)
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Loading Advice Creation - {propsData?.orderSchedulingNr}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Line Items */}
        <div className="accordion  mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PD</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Product </span>
                  <span className="subHeaderTitle">Product details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <DataTable
                          title=""
                          columns={lineItemCol}
                          data={lineItmes}
                          // data={getOrderlinItems}
                          // progressPending={orderSchedulingData?.status}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          // paginationTotalRows={orderSchedulingTable.total}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          // selectableRows
                        />
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {!viewStatus && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end"
            >
              <button
                className="btnTable btn-danger mt-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end">
              <button
                className="btnTable mt-2"
                onClick={handleSave}
                disabled={disabled}
              >
                Save
              </button>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
});

export default LoadingAdviceModal;
